import { render } from "./AlertCircleOutline.vue?vue&type=template&id=da40788e"
import script from "./AlertCircleOutline.vue?vue&type=script&lang=js"
export * from "./AlertCircleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__